import { ACTION_TYPES, TIMELINE_ITEM_HEIGHT, TIMELINE_ROW_HEIGHT } from '@/roadmaps/constants/roadmaps.constants';
import { getFirstPendingActionByType } from '@/roadmaps/use/use-pending-actions';
import useScroll from '@/roadmaps/use/use-scroll';
import { getRowFromY, getSwimlaneBodyBounds, getSwimlaneBodyHeight } from '@/roadmaps/use/use-swimlanes';
// eslint-disable-next-line no-restricted-imports
import store from '@/vuex/store';
import clamp from 'lodash/clamp';

export function getElementPadding (element) {
    const paddingTop = window.getComputedStyle(element, null).getPropertyValue('padding-top');
    const paddingRight = window.getComputedStyle(element, null).getPropertyValue('padding-right');
    const paddingBottom = window.getComputedStyle(element, null).getPropertyValue('padding-bottom');
    const paddingLeft = window.getComputedStyle(element, null).getPropertyValue('padding-left');

    return {
        top: parseInt(paddingTop),
        right: parseInt(paddingRight),
        bottom: parseInt(paddingBottom),
        left: parseInt(paddingLeft),
    };
}

export function snapToSwimlaneRow ({ y, swimlaneId }) {
    const swimlaneHeight = getSwimlaneBodyHeight(swimlaneId);
    const clampedY = clamp(y, 0, swimlaneHeight);

    return getRowFromY(swimlaneId, clampedY);
}

export function xRelativeToSwimlane (x, swimlaneId) {
    const swimlaneBodyBounds = getSwimlaneBodyBounds(swimlaneId);
    const { scrollPosition } = useScroll();

    return x - swimlaneBodyBounds.innerLeft + scrollPosition.left;
}

export function yRelativeToSwimlane (y, swimlaneId) {
    const { innerTop } = getSwimlaneBodyBounds(swimlaneId);

    return y - innerTop;
}

export function swimlaneXRelativeToBody (x) {
    const { scrollPosition } = useScroll();

    return x - scrollPosition.left;
}

export function swimlaneYRelativeToDocumentBody (y, swimlaneId) {
    const { innerTop } = getSwimlaneBodyBounds(swimlaneId);

    // 52px is the height of the new nav bar. We can go to the dom to get this but not sure if it's worth it
    return y + innerTop - 52;
}

export function calculateItemHeight (item) {
    if (!item.isExpanded) return TIMELINE_ROW_HEIGHT;

    let numRows = store.getters['roadmaps/items/childItemsWithoutDraggedItem'](item.id).length + 1;

    // If the item is a nesting target, add another row for the child ghost
    const isPendingNestTarget = getFirstPendingActionByType(ACTION_TYPES.NEST)?.targetItem.id === item.id;
    if (isPendingNestTarget) numRows++;

    return numRows * TIMELINE_ROW_HEIGHT + (TIMELINE_ROW_HEIGHT - TIMELINE_ITEM_HEIGHT);
}
